import Delegate from '//www.ohmycream.com/cdn/shop/t/168/assets/ftdomdelegate.min.js?v=167457923630348017651677856387';

export class CollapseElement extends HTMLElement {

  connectedCallback() {
    this._attachListener();
  }

  _attachListener() {
    new Delegate(this).on('click', '[data-action="toggle-collapsible"]', this._toggleCollapsible.bind(this));
    new Delegate(this).on('click', '[aria-close]', this._closeAllCollapse.bind(this));
    new Delegate(this).on('click', '[data-action="see-more"]', this._toggleSeeMore.bind(this));
  }

  get forceCloseAllItems() {
    return this.getAttribute('force-close-all');
  }


  //------------------------------------
  //-- Toggle collapse
  //------------------------------------
  _toggleCollapsible(event, target) {
    event.preventDefault();
    let collapseHeader = target;
    let collapseContent = document.getElementById(collapseHeader.getAttribute('aria-controls'));
    let element = collapseHeader.getAttribute('data-element');
    let heightContent = collapseHeader.getAttribute('open-height');
    let isOpen = collapseHeader.getAttribute('aria-expanded') === 'true';
    let isOpenContent = collapseContent.getAttribute('aria-expanded') === 'true';

    /*if(element){
      this._closeAllCollapse('data-element="'+element+'"', collapseHeader);
    }*/

    // If force close all items is set to true, close all items and open the target
    if (this.forceCloseAllItems) {
      this._closeAllCollapse(null, null, 'data-action="toggle-collapsible"', collapseHeader, true);
    }


    if (element === 'height') {
      if (!isOpen) {
        if (window.matchMedia('(max-width: 981px)').matches) {
          if (heightContent) {
            collapseContent.style.height = heightContent + 'px';
          } else {
            collapseContent.style.height = collapseContent.scrollHeight + 'px';
          }
        } else {
          collapseContent.style.height = collapseContent.scrollHeight + 'px';
        }
      } else {
        collapseContent.style.height = '0';
      }
    }

    if (element === 'fullPopin') {
      let body = document.querySelector("body");
      let sidebarContainer = document.querySelector("#collection-filter-form");
      if (!isOpenContent) {
        body.style.overflow = "hidden";
        if (sidebarContainer) {
          sidebarContainer.style.zIndex = "30";
        }
      } else {
        body.style.overflow = "initial";
        if (sidebarContainer) {
          setTimeout(function () {
            sidebarContainer.style.zIndex = "29";
          }, 500);
        }
      }
    }

    if (this.forceCloseAllItems) {
      collapseContent.setAttribute('aria-expanded', !isOpen ? 'true' : 'false');
      collapseHeader.setAttribute('aria-expanded', !isOpen ? 'true' : 'false');
    } else {
      collapseContent.setAttribute('aria-expanded', collapseContent.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
      collapseHeader.setAttribute('aria-expanded', collapseHeader.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
    }
  }

  _toggleSeeMore(event, target) {
    event.preventDefault();
    let collapseHeader = target;
    let collapseContent = document.getElementById(collapseHeader.getAttribute('aria-controls'));
    let heightContent = collapseHeader.getAttribute('close-height');
    let isOpen = collapseHeader.getAttribute('aria-expanded') === 'true';

    if (!isOpen) {
      collapseContent.style.height = collapseContent.scrollHeight + 'px';
    } else {
      if (heightContent) {
        collapseContent.style.height = heightContent + 'px';
      } else {
        collapseContent.style.height = collapseContent.scrollHeight + 'px';
      }
    }

    collapseHeader.setAttribute('aria-expanded', collapseHeader.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
  }

  //------------------------------------
  //-- Close all collapse
  //------------------------------------

  //_closeAllCollapse(collapseToClose, collapseTarget, forceClose){
  _closeAllCollapse(event, target, collapseToClose, collapseTarget = null, forceClose = true) {

    if (target) collapseToClose = target.getAttribute('aria-close');
    let collapse = document.querySelectorAll("[" + collapseToClose + "]");

    // Loop through element and close all except target
    for (let i = 0; i < collapse.length; i++) {
      if (collapse[i] !== collapseTarget || forceClose) {
        let collapseToClose = document.getElementById(collapse[i].getAttribute('aria-controls'));
        collapse[i].setAttribute('aria-expanded', 'false');
        if (collapseToClose) {
          collapseToClose.style.height = '0';
        }
      }
    }
  }
}

try {
  //window.customElements.define('collapse-element', CollapseElement), {extends: 'div'};
  window.customElements.define('collapse-element', CollapseElement);
} catch (e) { }